<template>
  <div class="c-card-wrap">
    <div class="c-card" v-for="(chapter,index) in lessonInfo.chapters" :key="index">
      <div class="c-label ohidden">{{chapter.title}}</div>
      <div class="c-toggle" @click="toggle(index)" :class="{close: !chapter.show}">
        <i class="icon-gengduoyonghu iconfont"></i>
      </div>
      <div class="c-card-list" :style="{height: (chapter.show ? listHeights[index] : 0) + 'px'}">
        <ul class="c-list" :id="'list'+index">
          <li
            class="c-item"
            v-for="item in chapter.articles"
            :key="item.id"
            @click="jumpToApp(item.lock, !!lessonInfo.readPermission, item)"
          >
            <trainListItem
              :item="item"
              :goodsType="goodsType"
              :chapter="true"
              v-if="goodsType == constants.goodsType.training"
            ></trainListItem>
            <courseListItem
              :item="item"
              :goodsType="goodsType"
              :chapter="true"
              v-if="goodsType == constants.goodsType.course"
            ></courseListItem>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import trainListItem from './train-list-item.vue'
import courseListItem from './course-list-item.vue'
import { saveUserInfo } from '@/utils/storage'
export default {
  components: {
    trainListItem,
    courseListItem,
  },
  props: {
    lessonInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    resourceId: {
      type: [Number, String],
      default: 0,
    },
    goodsType: {
      type: [Number, String],
      default: 0,
    },
    goodsId: {
      type: [Number, String],
      default: 0,
    },
    query: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      show: true,
      listHeights: {},
      isClicked: true,
    }
  },
  watch: {
    lessonInfo: {
      deep: true,
      immediate: true,
      handler(v) {
        nextTick(() => {
          this.lessonInfo.chapters.forEach((it, index) => {
            let h = document.getElementById('list' + index).offsetHeight
            this.listHeights[index] = h
            this.$forceUpdate()
          })
        })
      },
    },
  },
  methods: {
    toggle(index) {
      this.$emit('toggle', index)
    },
    async userLoginInfo() {
      if (this.isClicked) return
      this.isClicked = true
      let res = await this.api.login.userLoginInfo()
      if (res && res.code == 200) {
        saveUserInfo(res.data)
        this.$router.push({
          name: 'payment',
          query: {
            ...this.query,
            id: this.goodsId,
            isGoodsGroup: 0,
            memberVip: 0, //是否会员（0:不是 1：会员）
          },
        })
      }
      this.isClicked = false
    },
    jumpToGuide() {
      this.$router.push({
        name: 'download',
      })
    },
    jumpToApp(lock, readPermission, item) {
      if (item.type == 0) {
        if (this.origin != 'miniprogram') {
          this.$messageBox({
            title: '打开更新学堂APP去查看作业详情',
            show: true,
            btnType: 2,
            cancelBtnText: '暂不查看',
            confirmBtnText: '去查看',
            showOpenApp: true,
            origin: this.origin,
            confirmCallback: () => {
              // 跳转app
              if (this.origin == 'miniprogram') {
                this.jumpToGuide()
              } else {
                this.openApp()
              }
            },
          })
        }
        return
      }
      if (readPermission) {
        // 已购
        // 未到日期（提示）
        if(lock){ 
          return alert(item.tips)
        }
        this.$router.push({
          name: 'course-study',
          query: {
            goodsType: this.goodsType,
            goodsId: this.goodsId,
            resourceId: this.resourceId,
            id: item.id,
            adminId: '',
          },
        })
      } else {
        if (lock) {
          let self = this
          this.$messageBox({
            title: '购买课程解锁完整内容',
            show: true,
            btnType: 2,
            cancelBtnText: '暂不考虑',
            confirmBtnText: '立即购买',
            isMobileWx: false,
            confirmCallback: () => {
              if (
                self.goodsType == self.constants.goodsType.course ||
                self.goodsType == self.constants.goodsType.column
              ) {
                self.userLoginInfo()
              }
              if (self.goodsType == self.constants.goodsType.training) {
                self.$router.push({
                  path: '/timetable/schedule',
                  query: self.query,
                })
              }
            },
          })
        } else {
          // 试听
          this.$router.push({
            name: 'course-study',
            query: {
              goodsType: this.goodsType,
              goodsId: this.goodsId,
              resourceId: this.resourceId,
              id: item.id,
              adminId: '',
            },
          })
        }
      }
      // let title = '打开更新学堂APP，免费试听课程'
      // let cancelBtnText = '暂不试听'
      // let confirmBtnText = '去试听'
      // this.$messageBox({
      //   title: title,
      //   show: true,
      //   btnType: 2,
      //   cancelBtnText: cancelBtnText,
      //   confirmBtnText: confirmBtnText,
      //   showOpenApp: true,
      //   confirmCallback: () => {
      //     // 跳转app
      //     this.openApp()
      //   },
      // })
    },
  },
}
</script>

<style lang="less" scoped>
.c-card-wrap {
  padding: 0 12px;
}
.c-card {
  padding-top: 10px;
  position: relative;
  .c-toggle {
    width: 100px;
    height: 92px;
    position: absolute;
    top: 10px;
    right: 0px;
    i {
      position: absolute;
      top: 25px;
      right: 10px;
      font-size: 32px;
      color: #dddddd;
      transform: rotate(-90deg);
    }
    &.close {
      i {
        transform: rotate(90deg);
      }
    }
  }
}
.c-label {
  width: 600px;
  line-height: 92px;
  height: 92px;
  font-size: 32px;
  font-weight: 600;
  color: #333333;
}
.c-card-list {
  overflow: hidden;
  transition: height 0.3s;
}
.c-list {
  background: #f7f7f7;
  border-radius: 12px;
  padding: 0 30px;
  // .c-item {
  //   padding: 6px 0 30px;
  //   position: relative;
  //   border-bottom: 1px solid #eee;
  //   .c-title {
  //     width: 560px;
  //     font-size: 30px;
  //     font-weight: 400;
  //     color: #333333;
  //     line-height: 40px;
  //     max-height: 110px;
  //     padding: 15px 0;
  //   }
  //   .c-type {
  //     display: inline-block;
  //     width: 72px;
  //     line-height: 34px;
  //     border-radius: 6px;
  //     border: 2px solid #aaaaaa;
  //     font-size: 22px;
  //     font-weight: 400;
  //     color: #888888;
  //     text-align: center;
  //   }
  //   .c-try {
  //     font-size: 26px;
  //     color: #ff5500;
  //     line-height: 1;
  //     position: absolute;
  //     z-index: 1;
  //     top: 30px;
  //     right: 5px;
  //   }
  //   .c-time {
  //     width: 102px;
  //     line-height: 34px;
  //     font-size: 24px;
  //     color: #888888;
  //     padding-left: 20px;
  //     span {
  //       padding-left: 20px;
  //     }
  //   }
  // }
}
</style>